import { OrderDirection } from '../models';

export const getAriaSort = (orderDirection: OrderDirection): 'ascending' | 'descending' =>
  orderDirection === OrderDirection.ASC ? 'ascending' : 'descending';
